<template>
  <div v-if="hasPermission" id="home" class="container-fluid">
    <div id="customer-section" class="section-title">
      概况统计
      <month-selector v-model="curMoth"></month-selector>
    </div>
    <div class="row no-padding" v-loading="loading2">
      <div class="col-md-8">
        <div class="agent-info">
          <div class="qrcode" :style="{ backgroundImage: 'url(' + myQrCode + ')' }">
            <div v-if="!myQrCode">加载中..</div>
          </div>
          <div class="user-info">
            <div class="field">
              <label>名称</label>
              <ellipsis-text :content="auth.displayName">
                {{ auth.displayName }}
              </ellipsis-text>
            </div>
            <div class="field">
              <label>手机</label>
              <div>{{ auth.phone || auth.userName }}</div>
            </div>
            <div class="field">
              <label>角色</label>
              <div>{{ auth.role }}</div>
            </div>
            <div class="field">
              <el-button type="text" style="padding: 0" @click="doSaveQr">保存二维码</el-button>
            </div>
            <div class="field">
              <el-button type="text" style="padding: 0" @click="doCopyLink">复制推广链接</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="statistic">
          <div class="title">客户</div>
          <div>
            <div class="val">{{ statistic.customerAll || 0 }}</div>
            <div class="key">累计</div>
          </div>
          <div>
            <div class="val">+{{ statistic.customerMonth || 0 }}</div>
            <div class="key">当月</div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="statistic">
          <div class="title">服务订单</div>
          <div>
            <div class="val">{{ statistic.serviceAll || 0 }}</div>
            <div class="key">累计</div>
          </div>
          <div>
            <div class="val">{{ statistic.serviceMonth || 0 }}</div>
            <div class="key">当月</div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="statistic">
          <div class="title">配件订单</div>
          <div>
            <div class="val">{{ statistic.partAll || 0 }}</div>
            <div class="key">累计</div>
          </div>
          <div>
            <div class="val">{{ statistic.partMonth || 0 }}</div>
            <div class="key">当月</div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="statistic">
          <div class="title">配件售后</div>
          <div>
            <div class="val">{{ statistic.partReturnAll || 0 }}</div>
            <div class="key">累计</div>
          </div>
          <div>
            <div class="val">{{ statistic.partReturnMonth || 0 }}</div>
            <div class="key">当月</div>
          </div>
        </div>
      </div>
    </div>
    <div id="customer-section" class="section-title">客户统计</div>
    <div class="row customer-info no-padding">
      <div class="col-lg-8 chart-wraper">
        <div class="header">
          <div>客户数量</div>
          <div>
            <time-span v-model="customerLineSpan" />
          </div>
        </div>
        <div class="inner">
          <customer-line-chart :time-span="customerLineSpan" />
        </div>
      </div>
      <div class="col-lg-8 chart-wraper">
        <div class="header">
          <div>消费占比</div>
          <div>
            <time-span-selector v-model="customerPercentSpan" />
          </div>
        </div>
        <div class="inner">
          <customer-gauge-chart :time-span="customerPercentSpan" />
        </div>
      </div>
      <div class="col-lg-8 chart-wraper">
        <div class="header">
          <div>消费Top50</div>
          <div>
            <time-span-selector v-model="customerTopSpan" />
          </div>
        </div>
        <div class="inner">
          <customer-bar-stack-chart :time-span="customerTopSpan" />
        </div>
      </div>
    </div>
    <div id="order-section" class="section-title">订单统计</div>
    <div class="row order-info">
      <div class="col-lg-8 chart-wraper">
        <div class="header">
          <div>品牌统计</div>
          <div>
            <time-span-selector v-model="orderBrandPieSpan" />
          </div>
        </div>
        <div class="inner">
          <order-brand-amount-chart :time-span="orderBrandPieSpan" />
        </div>
      </div>
      <div class="col-lg-8 chart-wraper">
        <div class="header">
          <div>
            配件销售
            <el-button v-uac="'home.partOrderExp'" data-uac="home.partOrderExp$$首页.配件销售导出" size="mini" type="text" style="margin-left: 8px;" @click="doExp">导出</el-button>
            <el-button size="mini" type="text" style="margin-left: 8px;" @click="doZoom(1)">放大</el-button>
          </div>
          <div>
            <time-span v-model="orderLineSpan" />
          </div>
        </div>
        <div class="inner">
          <order-line-chart ref="orderLineChart" :time-span="orderLineSpan" />
        </div>
      </div>
      <div class="col-lg-8 chart-wraper">
        <div class="header">
          <div>
            区域统计
            <el-button v-uac="'home.partOrderExp'" size="mini" type="text" style="margin-left: 8px;" @click="doExpByArea">导出</el-button>
            <el-button size="mini" type="text" style="margin-left: 8px;" @click="doZoom(2)">放大</el-button>
          </div>
          <div>
            <time-span-selector v-model="orderDiscountSpan" />
          </div>
        </div>
        <div class="inner">
          <OrderStatisticByMap ref="orderLineChartByArea" :time-span="orderDiscountSpan" />
        </div>
      </div>
    </div>
  </div>
  <div v-else class="no-permisson">
    Welcome!
  </div>
</template>
<script>
import Utils from '@/utils'
import _ from 'lodash'
import CopyText from '@/libs/copyer'
import download from '@/libs/downloadfile'
import MonthSelector from '@/components/MonthSelector.vue'
import CustomerLineChart from './partials/CustomerLineChart.vue'
import CustomerGaugeChart from './partials/CustomerGaugeChart.vue'
import CustomerBarStackChart from './partials/CustomerBarStackChart.vue'
import OrderLineChart from './partials/OrderLineChart.vue'
import OrderBrandAmountChart from './partials/OrderBrandAmountChart.vue'
import OrderStatisticByMap from './partials/OrderStatisticByMap.vue'
import TimeSpanSelector from '@/components/TimeSpanSelector.vue'
import { LoadSummaryStatistic } from './services.js'
import TimeSpan from '@/components/TimeSpan.vue'
import moment from 'moment'
export default {
  name: 'HomePage',
  components: { CustomerLineChart, CustomerGaugeChart, CustomerBarStackChart, OrderStatisticByMap, OrderLineChart, OrderBrandAmountChart, TimeSpanSelector, TimeSpan, MonthSelector },
  data () {
    const now = new Date()
    const endTime = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)
    const startTime = new Date(now.getFullYear(), now.getMonth(), 1)
    return {
      myQrCode: undefined,
      customerLineSpan: {
        range: [startTime, endTime],
        rangeType: 'daterange'
      },
      customerTopSpan: [startTime, endTime],
      customerPercentSpan: [startTime, endTime],
      orderLineSpan: {
        range: [startTime, endTime],
        rangeType: 'daterange',
        isOrder: true,
        partType: undefined
      },
      orderDiscountSpan: [startTime, endTime],
      orderBrandPieSpan: [startTime, endTime],
      curMoth: undefined,
      statistic: {},
      loading2: false
    }
  },
  computed: {
    auth () {
      return this.$store.state.auth || {}
    },
    proxyUrl () {
      return `http://m.zhaopeiyun.com/m/zpc/register?proxyCode=${this.auth.proxyCode}`
    },
    hasPermission () {
      return !(this.$store.state.privileges || []).length || ~(this.$store.state.privileges || []).indexOf('m.home')
    }
  },
  watch: {
    newAdd () {
      this.loadSummaryStatisticDebounce()
    },
    area () {
      this.loadSummaryStatisticDebounce()
    },
    curMoth () {
      this.loadSummaryStatisticDebounce()
    }
  },
  async beforeMount () {
    this.myQrCode = await Utils.QrCodeImage(this.proxyUrl)
    this.loadSummaryStatisticDebounce = _.debounce(() => {
      this.loadSummaryStatistic()
    }, 300, {
      leading: true,
      trailing: true
    })
    this.loadSummaryStatisticDebounce()
  },
  methods: {
    doCopyLink () {
      CopyText(this.proxyUrl).then(() => {
        this.$message.success('已复制到剪贴板')
      })
    },
    doSaveQr () {
      download(this.myQrCode, `兆配云-${this.auth.displayName}.png`)
    },
    loadSummaryStatistic () {
      let endDay, startDay
      if (this.curMoth) {
        endDay = moment(this.curMoth).add(1, 'months').format('YYYY-MM-DD')
        startDay = moment(this.curMoth).format('YYYY-MM-DD')
      }
      this.loading2 = true
      LoadSummaryStatistic({ newAdd: this.newAdd, area: this.area || undefined, startDay, endDay }).then(resp => {
        this.statistic = resp
      }).finally(() => {
        this.loading2 = false
      })
    },
    doExp () {
      if (this.$refs.orderLineChart) {
        this.$refs.orderLineChart.$emit('exportExcel')
      }
    },
    doExpByArea () {
      if (this.$refs.orderLineChartByArea) {
        this.$refs.orderLineChartByArea.$emit('exportExcel')
      }
    },
    doZoom (type) {
      this.modal('ZoomModal', type).promise.catch(() => {})
    }
  }
}
</script>
